import React from 'react';

// Test component that intentionally throws an error
const ErrorTestPage: React.FC = () => {
  const [shouldThrowError, setShouldThrowError] = React.useState(false);

  if (shouldThrowError) {
    throw new Error('테스트 에러: ErrorBoundary 동작 확인');
  }

  return (
    <div style={{ padding: '150px 20px', textAlign: 'center' }}>
      <h1>ErrorBoundary 테스트 페이지</h1>
      <p>아래 버튼을 클릭하면 의도적으로 에러가 발생합니다.</p>
      <button
        onClick={() => setShouldThrowError(true)}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          background: '#fc8181',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        에러 발생시키기
      </button>
    </div>
  );
};

export default ErrorTestPage;
